var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAuthorizedDevicesWithWhiteCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_27_8226)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_27_8226",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 50,
    height: 50
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50 0H0V50H50V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_27_8226)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.997 49.0251C19.455 49.021 14.0848 47.1016 9.79588 43.5918C5.50697 40.082 2.56306 35.1976 1.46277 29.7659C0.36248 24.3343 1.17345 18.6893 3.75833 13.7871C6.34321 8.88482 10.5431 5.02674 15.6466 2.86627C20.7809 0.692223 26.5116 0.371834 31.8562 1.96002C37.2008 3.54821 41.8266 6.94606 44.9405 11.5711C48.0544 16.1962 49.4625 21.7603 48.9235 27.3098C48.3845 32.8593 45.9318 38.0485 41.9861 41.9878C39.7575 44.2223 37.1094 45.9943 34.1938 47.202C31.2783 48.4096 28.1528 49.0292 24.997 49.0251ZM9.79084 32.4855V34.9798H39.7263V32.4855H34.7396C35.3986 32.4823 36.0295 32.2181 36.4942 31.7507C36.9589 31.2833 37.2194 30.6509 37.2189 29.9918L37.232 17.5184C37.2307 16.8567 36.9669 16.2226 36.4986 15.7552C36.0303 15.2878 35.3957 15.0252 34.734 15.0251H14.7795C14.1183 15.0256 13.4843 15.2885 13.0167 15.7559C12.5491 16.2234 12.286 16.8572 12.2852 17.5184V29.9918C12.286 30.653 12.5491 31.2869 13.0167 31.7544C13.4843 32.2218 14.1183 32.4846 14.7795 32.4852L9.79084 32.4855ZM34.7339 29.9918H14.7795V17.5187H34.7339V29.9918Z",
    fill: "#F9F9F9"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_27_8226"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuthorizedDevicesWithWhiteCircle);
export default __webpack_public_path__ + "static/media/authorized_devices_with_white_circle.b573b35f057497061c0ed19ef964bb81.svg";
export { ForwardRef as ReactComponent };